import { ITokenInfo } from "~/types/global"
import { axiosInstance } from "~/utils/axios"

export async function getTenant(
  tokenInfo: ITokenInfo,
  linkedTenantId?: number
) {
  const tenantId = tokenInfo?.tenant_id
  let url = `/tenants/${tenantId}/`
  if (linkedTenantId) {
    url += `?linked_tenant_id=${linkedTenantId}`
  }
  return await axiosInstance({
    method: "GET",
    url,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    }
  })
}
